import { Box } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { toast } from 'react-toastify';
import EditSaveActions from 'Shared/Button/EditSaveActions';
import useForm from 'Shared/Hooks/useForm';
import Input from 'Shared/Input/v2';
import ReferencialContext from 'Shared/ReferencialContext';
import AutoCompleteCmp from 'Shared/Select/AutoCompleteCmp';
import { roundPrice } from 'Utils/ulilities';

const styleInpt = {
  marginTop: 8, marginBottom: 4, minWidth: '150px', border: '1px solid #007BC6',
};

const DocumentVenteProduct = ({
  documentProducts, saveProduct,
  onClose, onEditLine, onRemoveLine, productLine,
}) => {
  const {
    state: { referencial: { products } },
  } = useContext(ReferencialContext);

  const { values, onChange, onSelect } = useForm({
    productName: '', remise: '', price: '', amountTtc: '', ...productLine,
  });
  const onHandleSave = () => {
    const { isNewLine, ...productDetails } = values;
    const isExist = documentProducts.find((p) => p.product.reference === productDetails.reference);
    if (isExist && isNewLine) {
      toast.error('Produit existe sur le document de vente');
      return;
    }
    // check all fields are not empty
    if (isNewLine) {
      saveProduct([...documentProducts, { ...productDetails, onEditLine, onRemoveLine }]);
      onClose();
      return;
    }
    const newProducts = documentProducts.map((p) => (
      p.product.reference === productDetails.product.reference
        ? { ...productDetails, onEditLine, onRemoveLine } : p));
    saveProduct(newProducts);
    onClose();
  };
  useEffect(() => {
    if (values?.product) {
      onChange({ target: { name: 'productName', value: values?.product.des } });
      onChange({ target: { name: 'remise', value: values?.product.r } });
      onChange({ target: { name: 'price', value: values?.product.p } });
    }
  }, [values?.product]);

  useEffect(() => {
    const applyDiscount = values?.remise
      ? (values?.remise * values?.price) / 100 : 0;
    const needQuantity = values?.quantity;
    const priceP = values?.price;
    if (priceP >= 0 && needQuantity >= 0) {
      const ttc = roundPrice(needQuantity * (priceP - applyDiscount));
      onChange({ target: { name: 'amountTtc', value: ttc } });
    }
  }, [values?.price, values?.quantity, values?.remise]);

  return (
    <>
      <Box sx={{
        mt: 0.4,
        mb: 0.4,
        p: 1,
        display: 'flex',
        overflow: 'auto',
        borderRadius: 1.4,
        background: '#D9E8F6',
        '::-webkit-scrollbar': { height: '7px' },
        '::-webkit-scrollbar-track': { background: '#007bc663' },
        '::-webkit-scrollbar-thumb': {
          background: '#007bc6c2',
          borderRadius: '10px',
        },
        '::-webkit-scrollbar-thumb:hover': { background: '#007BC6' },
      }}
      >
        <AutoCompleteCmp
          options={products}
          onChange={(e, value) => onSelect('product', value)}
          getOptionLabel={(option) => option.reference}
          filterOptions={
            (options, v) => options.filter((option) => option.reference?.toLowerCase()
              .includes(v.inputValue.toLowerCase()))
        }
          value={values.product}
          label="Référence*"
          isPrimaryTheme
          style={{
            ...styleInpt, display: 'inline-block',
          }}
        />
        <Input
          value={values.productName}
          onChange={onChange}
          style={styleInpt}
          label="DÉSIGNATION"
          name="productName"
        />
        <Input
          value={values.price}
          onChange={onChange}
          style={styleInpt}
          label="PRIX"
          name="price"
          type="number"
        />
        <Input
          value={values.quantity}
          onChange={onChange}
          style={styleInpt}
          label="QTÉ"
          name="quantity"
          type="number"
        />
        <Input
          value={values.remise}
          onChange={onChange}
          style={styleInpt}
          label="REMISE"
          name="remise"
          type="number"
        />
        <Input
          value={values.amountTtc}
          onChange={onChange}
          style={styleInpt}
          label="MONTANT TTC"
          name="amountTtc"
          type="number"
        />
        <Box sx={{ mt: 1.2, mb: 0.6, display: 'flex' }}>
          <EditSaveActions
            isEdit
            onHandleClose={onClose}
            onHandleEdit={onClose}
            onHandleSave={onHandleSave}
          />
        </Box>
      </Box>
    </>
  );
};

export default DocumentVenteProduct;
